import type { ReactNode } from 'react'
import { Hammer } from 'lucide-react'
import { LinkButton } from '@/components/base/Button'
import { useLanguage } from '@/localization'

interface ComingSoonProps {
  title: string
  description: string
  children?: ReactNode
}

/** Shared polished "Coming Soon" placeholder section. */
export default function ComingSoon({ title, description, children }: ComingSoonProps) {
  const { t } = useLanguage()

  return (
    <div className="max-w-3xl mx-auto px-4 py-20 text-center">
      <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gold/20 text-gold-dark border-2 border-gold/50 mb-6 animate-float">
        <Hammer size={40} />
      </div>
      <span className="inline-block px-4 py-1 rounded-full bg-gold/20 text-gold-dark border border-gold/50 text-sm font-bold tracking-wide mb-4">
        {t('Coming Soon')}
      </span>
      <h1 className="text-4xl md:text-5xl font-extrabold text-slate-deep mb-4">{t(title)}</h1>
      <p className="text-lg text-slate-deep/70 mb-8">{t(description)}</p>
      {children}
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <LinkButton to="/" variant="primary">
          {t('Back to home')}
        </LinkButton>
        <LinkButton to="/servers" variant="outline">
          {t('View servers')}
        </LinkButton>
      </div>
    </div>
  )
}
